export default "__VITE_ASSET__CL0kYW1Z__"